import React from 'react';
import { PageTitleAnnouncer, usePageTitleAnnouncer } from './PageTitleAnnouncer';
import PageTitle from './PageTitle';
import { DocumentTitleProvider, useSetDocumentTitle } from './DocumentTitleProvider';
import { jsx as _jsx } from "react/jsx-runtime";
function PageTitleManager(_ref) {
  var pathname = _ref.pathname,
    baseTitle = _ref.baseTitle,
    _ref$syncDocumentTitl = _ref.syncDocumentTitle,
    syncDocumentTitle = _ref$syncDocumentTitl === void 0 ? false : _ref$syncDocumentTitl,
    children = _ref.children;
  return /*#__PURE__*/_jsx(DocumentTitleProvider, {
    baseTitle: baseTitle,
    isDisabled: !syncDocumentTitle,
    children: /*#__PURE__*/_jsx(PageTitleAnnouncer, {
      pathname: pathname,
      children: children
    })
  });
}
export { PageTitleManager, PageTitleAnnouncer, usePageTitleAnnouncer, DocumentTitleProvider, useSetDocumentTitle };
export default PageTitle;